import type { ResolveStepAutoFill } from '@/features/campaigns/components/CreateCampaign_v2/steps/Whatsapp/types';
import {
  createNamedTemplateEditFlowHandler,
  type NamedTemplateSelection,
} from '@/features/campaigns/components/CreateCampaign_v2/steps/Whatsapp/namedTemplateEditFlowHandler';

export const createEmailEditFlowHandler = (selection?: NamedTemplateSelection): ResolveStepAutoFill =>
  createNamedTemplateEditFlowHandler(selection);
